import { memo, useCallback } from 'react';
import { FavoritesToggleProps } from './FavoritesToggle.types';
import { Box, Icon, PressableOverlay } from '@bonanza-social/moonlight';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { favoriteGame, selectGame, unfavoriteGame } from '../../../../state';

function FavoritesToggle({ gameId, imageType }: FavoritesToggleProps) {
  const dispatch = useDispatch();
  const game = useSelector(selectGame(gameId));
  const favorited = game?.displayFeatures.Favorite;

  const onPress = useCallback(async () => {
    const action = favorited ? unfavoriteGame : favoriteGame;

    await dispatch(action(gameId));
  }, [favorited, dispatch, gameId]);

  return (
    <Box
      position="absolute"
      right="space-100"
      bottom={imageType === 'square' ? 'space-050' : 'space-200'}
      padding="space-100"
      borderRadius="radius-400"
      backgroundColor="backdropPrimary"
      overflow="hidden"
      renderToHardwareTextureAndroid
    >
      <Icon
        name={favorited ? 'favoriteFilled' : 'favoriteBorderFilled'}
        color="iconSecondary"
      />
      <PressableOverlay onPress={onPress} />
    </Box>
  );
}

export default memo(FavoritesToggle);
